import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
// styles
import useStyles from "../../styles";
import { Grid, Button } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {configureDashlet,getCurrentTab } from "../../../../../../store/actions/dashboard.actions";
import { toast } from "react-toastify";
import { FormInput, AORConditions } from "../../../../..";
import { TransferList } from "..";
import CircularProgress from '@material-ui/core/CircularProgress';
import { pathOr } from "ramda";
import { Scrollbars } from 'react-custom-scrollbars';
import AddCustomTile from "../../../AddCustomTile";

export default function FormDialog({ editDashletData, module, data, openEditDialog, setOpenEditDialog, setConfiguredDashlet, configuredDashlet,addDashlet,value }) {


    const { configureDashletLoading } = useSelector((state) => state.dashboard);
    const classes = useStyles();
    // const [toast, setToast] = useState({ toastVisible: false, toastMessage: '' });
    const [columnChooser, setColumnChooser] = useState(editDashletData.columnChooser ? editDashletData.columnChooser : null);
    const [transferListLeftColumns, setTransferListLeftColumns] = useState(null);
    const [transferListRightColumns, setTransferListRightColumns] = useState(null);
    const [dashlet_id, setDashlet_id] = useState(data.id);
    const [initialState, setInitialState] = useState(editDashletData);
    const [filterAorConditions, setFilterAorConditions] = useState([]);
    const [isReportChanged, setIsReportChanged] = useState(false);

    // const { isAuthenticated } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    let searchFieldsData = pathOr(null, ['searchFields'], editDashletData);
    const [searchFields, setSearchFields] = useState(searchFieldsData);
    const [Filter_itms, setFilter_itms] = useState({});
    const parametersData = pathOr([], ['parameters'], editDashletData);
    const [parameters, setParameters] = useState(parametersData);
    const [customTileData, setCustomTileData] = useState(pathOr({}, ['data'], data));

    
    // console.log("parameters",parameters)
    let dashletOptionsData = module && module === 'AOR_Reports' ?
        [
            {
                'field_key': "dashletTitle",
                'name': "dashletTitle",
                'label': "Title",
                'type': "varchar",
                'default': pathOr('', ['dashletTitle'], initialState),
                'value': pathOr('', ['dashletTitle'], initialState),
                'comment': "Title",
            },
            {
                'field_key': "aor_report_id",
                'name': "aor_report_id",
                'label': "Report",
                'type': "relate",
                'default': pathOr('', ['aor_report_id'], initialState),
                'value': pathOr('', ['aor_report_id'], initialState),
                'module': 'AOR_Reports',
                'comment': "Report",
            },
             pathOr('', ['aor_report_id','id'], initialState)!=='' && pathOr([], ['chartoptionslist'], initialState).length!==0 ? {
                'field_key': "onlyCharts",
                'name': "onlyCharts",
                'label': "Only show charts",
                'type': "bool",
                'default': pathOr(false, ['onlyCharts'], initialState),
                'value': pathOr(false, ['onlyCharts'], initialState),
                'comment': "Only show charts",
            } : '',
            // pathOr([], ['chartOptions', 'options'], editDashletData).length ?

            pathOr('', ['aor_report_id','id'], initialState)!=='' && pathOr([], ['chartoptionslist'], initialState).length!==0 ? {
                'field_key': "chartOptions",
                'name': "chartOptions",
                'label': "Charts",
                'type': "multienum",
                'options': pathOr([], ['chartoptionslist'], initialState),
                'default': pathOr([], ['chartOptions'], initialState),
                'value': pathOr([], ['chartOptions'], initialState),
                'comment': "Charts",

            } : ''
            // : {}
        ] : editDashletData && editDashletData.hasOwnProperty('dashletTitle') ? [{
            'field_key': "dashletTitle",
            'name': "dashletTitle",
            'label': "Title",
            'type': "varchar",
            'default': pathOr('', ['dashletTitle'], initialState),
            'value': pathOr('', ['dashletTitle'], initialState),
            'comment': 'Title'
        }] : null;

    const [dashletOptions, setDashletOptions] = useState(dashletOptionsData);

    const websiteOptionsData = module === 'Home' ? [
        {
            'field_key': "title",
            'name': "title",
            'label': "Title",
            'type': "varchar",
            'default': pathOr('', ['title'], initialState),
            'value': pathOr('', ['title'], initialState),
            'comment': 'Title'

        },
        {
            'field_key': "url",
            'name': "url",
            'label': "Website Location",
            'type': "url",
            'default': pathOr('', ['url'], initialState),
            'value': pathOr('', ['url'], initialState),
            'comment': 'Website Location'

        },
        // {
        //     'field_key': "height",
        //     'name': "height",
        //     'label': "Dashlet Height (in pixels)",
        //     'type': "varchar",
        //     'default': pathOr('', ['height'], editDashletData),
        //     'value': pathOr('', ['height'], editDashletData)
        // },
    ] : null;
    const [websiteOptions, setWebsieteOptions] = useState(websiteOptionsData);

    const myItemsOnlyData = editDashletData && editDashletData.hasOwnProperty('myItemsOnly') ? {
        'field_key': "myItemsOnly",
        'name': "myItemsOnly",
        'label': "Only My Items",
        'type': "bool",
        'default': pathOr(false, ['myItemsOnly'], initialState),
        'value': pathOr(false, ['myItemsOnly'], initialState),
        'comment': 'Only My Items'

    } : null;
    const [myItemsOnly, setMyItemsOnly] = useState(myItemsOnlyData);

    // console.log("editDashletData")
    // console.log(dashletOptions)

    useEffect(() => {

        // websiteOptions && websiteOptions.map((field, fieldNum) => {
        //     initialState[field.name] = field.value;
        // })
        dashletOptions && dashletOptions.map((field, fieldNum) => {
            initialState[field.name] = field.value;
        })
        // if (myItemsOnly) {
        //     initialState[myItemsOnly.name] = myItemsOnly.value;
        // }
        // initialState.filter(function () { return true });
        // setInitialState(...initialState, initialState)


    }, [dashletOptions]);


    useEffect(() => {
        searchFields && searchFields.map((field, fieldNum) => (
            searchFields[fieldNum]['type'] = field.type === 'datetime' ? 'enum' : field.type,
            searchFields[fieldNum]['value'] = field.value || field.default,
            searchFields[fieldNum]['comment'] = field.label,

            Filter_itms[field.name] = field.value || field.default

        ))

    }, [searchFields])

    // useEffect(() => {
    //     console.log("filterAorConditions")
    //     console.log(filterAorConditions)

    // }, [filterAorConditions])
    const handleClose = () => {
        setOpenEditDialog(false);
    };
    const handleSubmitReportFilter = (filterData) => {
        // console.log(filterData)
    }
    const onChange = (value, field) => {
        // console.log("onChange")
        // console.log(value)
        // console.log(field)
        if (searchFields && searchFields.some(item => field.name === item.name)) {
            if (field.type === 'relate' && value === '') {
                Filter_itms[field.name] = { 'id': '', 'value': '' };
            } else {
                Filter_itms[field.name] = value;
            }
            // console.log("Filter_itms", Filter_itms)


        } else {

            initialState[field.name] = value;
            if (field.name === 'aor_report_id') {
                // dashletOptions.some(item => 'chartOptions' === item.name)
                let newCharts = pathOr([], ['rowData', 'attributes', 'aor_charts'], value);
                if (newCharts.length === 0) {
                    dashletOptions.splice(2, 1);
                    dashletOptions.splice(2, 1);
                } else {

                    dashletOptions[2] = {
                        'field_key': "onlyCharts",
                        'name': "onlyCharts",
                        'label': "Only show charts",
                        'type': "bool",
                        'default': false,
                        'value': false,
                        'comment': "Only show charts",
                    };

                    dashletOptions[3] = {
                        'field_key': "chartOptions",
                        'name': "chartOptions",
                        'label': "Charts",
                        'type': "multienum",
                        'options': newCharts,
                        'default': [],
                        'value': [],
                        'comment': "Charts",

                    };

                }
                // initialState['chartOptions'] = []
                setDashletOptions(dashletOptions)
                setParameters([])
                setFilterAorConditions([])
                // setIsReportChanged(false)
                setInitialState({ ...initialState, ['chartOptions']: {}, ['onlyCharts']: false, ['chartoptionslist']: {} })

                // console.log("dashletOptions ==", dashletOptions)

                // setIsReportChanged(true);

            
            }else if(field.name==='onlyCharts'){
                
                if(initialState['onlyCharts']){
                    // dashletOptions[3] = {
                    //     'field_key': "chartOptions",
                    //     'name': "chartOptions",
                    //     'label': "Charts",
                    //     'type': "multienum",
                    //     'options': initialState['chartoptionslist'],
                    //     'default': initialState['chartOptions'],
                    //     'value': initialState['chartOptions'],
                    //     'comment': "Charts",

                    // };
                    // setDashletOptions(dashletOptions)
                    setInitialState({ ...initialState, ['onlyCharts']: initialState['onlyCharts'] })
                }else{
                // dashletOptions.splice(3, 1);
                setInitialState({ ...initialState, ['onlyCharts']: initialState['onlyCharts'] })
                }
            }
        }

    }

    useEffect(() => {
        if (isReportChanged) {
            // dashletOptions.splice(2, 1);
            // dashletOptions.splice(2, 1);
            // initialState['chartOptions'] = []
            // initialState['onlyCharts'] = false;

        }
    }, [isReportChanged])
    const handleConfigure = () => {
        let params = {};
        if (module === 'AOR_Reports') {


            let chartOptionsValue = initialState['chartOptions'];
            if (!Array.isArray(chartOptionsValue) && chartOptionsValue.length) {
                if (chartOptionsValue.indexOf(',') > -1) {
                    chartOptionsValue = chartOptionsValue && chartOptionsValue.replace(/\^/g, "").split(",")
                } else {
                    chartOptionsValue = [chartOptionsValue.replace(/\^/g, "")]
                }
                // myVarToTest is not an array

            }
            let parameter_id = [];
            let parameter_operator = [];
            let parameter_type = [];
            let parameter_value = [];
            filterAorConditions.map((reportFilter, rNum) => {

                if (reportFilter !== undefined) {
                    if (reportFilter['id'] !== null) {
                        parameter_id[rNum] = reportFilter['parameter_id'] || parameters[rNum].id;
                        parameter_operator[rNum] = reportFilter['parameter_operator'] || parameters[rNum].operator;
                        parameter_type[rNum] = reportFilter['parameter_type'] || parameters[rNum].value_type;
                        parameter_value[rNum] = reportFilter['parameter_value'] || parameters[rNum].value;
                    }
                }

            })
            params = {
                "configureDashlet": {
                    "id": initialState['id'],
                    "module": "HomeApp",
                    "configure": "true",
                    "dashletTitle": initialState['dashletTitle'],
                    "aor_report_name": initialState['aor_report_id']['value'] ? initialState['aor_report_id']['value'] : pathOr(false, ['aor_report_name'], editDashletData),
                    "aor_report_id": initialState['aor_report_id']['id'] ? initialState['aor_report_id']['id'] : pathOr('', ['aor_report_id'], editDashletData),
                    "onlyCharts": initialState['onlyCharts'],
                    "charts": chartOptionsValue,
                    "parameter_id": parameter_id.filter(function (element) {
                        return element !== undefined;
                    }),
                    "parameter_operator": parameter_operator.filter(function (element) {
                        return element !== undefined;
                    }),
                    "parameter_type": parameter_type.filter(function (element) {
                        return element !== undefined;
                    }),
                    "parameter_value": parameter_value.filter(function (element) {
                        return element !== undefined;
                    }),
                }
            };
        } else if (module === 'Home') {
            params = {
                "configureDashlet": {
                    "id": initialState['id'],
                    "module": "HomeApp",
                    "configure": "true",
                    "url": initialState['url'],
                    "height": initialState['height']
                }
            };
        } else {



            params = {
                "configureDashlet": {
                    "id": pathOr("dafault", ['data','type'], data)==='custom'?pathOr("", ['data','id'], data):initialState['id'],
                    "module": "HomeApp",
                    "configure": "true",
                    "to_pdf": "true",
                    "displayColumnsDef": transferListLeftColumns,
                    "hideTabsDef": transferListRightColumns,
                    "dashletType": "",
                    "dashletTitle": initialState['dashletTitle'],
                    "displayRows": 5,
                    "autoRefresh": 10,
                    "myItemsOnly": initialState['myItemsOnly'],
                    "Filter_itms": Filter_itms,
                    'type':pathOr("dafault", ['data','type'], data),
                    'data':customTileData
                }

            };
        }
        try {
            dispatch(configureDashlet(params)).then(function (res) {
                if (res.data.status === 200) {
                    // toast('Dashlet Configured Successfully!');
                    setConfiguredDashlet(pathOr("", ['data','data','type'], res)==='custom'?res.data.data:res.data);
                    setOpenEditDialog(false);
                    dispatch(getCurrentTab(value, 'this_year')).then((res)=>{
                        toast('Dashboard Updated Successfully!')
                      })
                } else {
                    toast('Something went wrong!');

                }
            });
        } catch (e) {
            toast('Something went wrong!');

        }

    };
    const handleClear = () => {
        alert("clear")

    };

    // console.log("initialState",editDashletData,pathOr("", ['data','type'], data), data)
    return (
        <>


            <DialogTitle id="form-dialog-title">{ pathOr(editDashletData.dashletTitle || editDashletData.title, ['data','label'], data)}
            </DialogTitle>
            {pathOr("", ['data','type'], data)==='custom'?
<>            <DialogContent>
                <AddCustomTile addDashlet={addDashlet} data={customTileData} setCustomTileData={setCustomTileData}/>
            </DialogContent>
        
  </>      
            :<>
            <DialogContent>
                <Scrollbars autoHide={true} style={{ height: "60vh" }}>
                    <>
                        <Grid container>
                            {/* <h3>General</h3> */}
                            {/* Default Dashlet */}
                            {dashletOptions && dashletOptions.map((field, fieldNum) => (field.name ?
                                < Grid item xs={12} sm={12} key={fieldNum} >
                                    <Grid
                                        container
                                        className={classes.fieldSpacing}
                                        direction="row"
                                        justify="space-between"
                                        alignItems="stretch"
                                    >
                                        <Grid item xs={12}>
                                            <FormInput
                                                field={field}
                                                value={initialState[field.name]}
                                                dynamicEnumValue=""
                                                // errors={errors}
                                                module={field.module ? field.module : 'Users'}
                                                onChange={(val) => onChange(val, field)}
                                                small={true}

                                            />

                                        </Grid>
                                    </Grid>
                                </Grid> : null
                            ))}

                            {columnChooser ? <TransferList columnChooser={columnChooser} setTransferListLeftColumns={setTransferListLeftColumns} setTransferListRightColumns={setTransferListRightColumns} /> : null}
                            {/* Website */}
                            {websiteOptions && websiteOptions.map((field, fieldNum) => (

                                < Grid item xs={12} sm={12} key={fieldNum} >
                                    <Grid
                                        container
                                        className={classes.fieldSpacing}
                                        direction="row"
                                        justify="space-between"
                                        alignItems="stretch"
                                    >
                                        <Grid item xs={12}>
                                            <FormInput
                                                field={field}
                                                value={
                                                    initialState[field.name]
                                                }
                                                dynamicEnumValue=""
                                                // errors={errors}
                                                module='Users'
                                                onChange={(val) => onChange(val, field)}
                                                small={true}

                                            />

                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                            {parameters.length ? <h3>Filters</h3> : null}
                            {searchFields && <h3>Filters</h3>}
                            <Grid container spacing={3} >
                                {myItemsOnly ? <Grid item xs={12} sm={6} key={"myitemsonly-" + 1}>
                                    <Grid
                                        container
                                        className={classes.fieldSpacing}
                                        direction="row"
                                        justify="space-between"
                                        alignItems="stretch"
                                    >
                                        <Grid item xs={12}>
                                            <FormInput
                                                field={myItemsOnly}
                                                value={initialState[myItemsOnly.name]}
                                                dynamicEnumValue=""
                                                // errors={errors}
                                                onChange={(val) => onChange(val, myItemsOnly)}
                                                small={true}

                                            />

                                        </Grid>
                                    </Grid>
                                </Grid> : null}
                                {searchFields && searchFields.map((field, fieldNum) =>

                                    <>
                                        < Grid item xs={12} sm={6} key={fieldNum} >
                                            <Grid
                                                container
                                                className={classes.fieldSpacing}
                                                direction="row"
                                                justify="space-between"
                                                alignItems="stretch"
                                            >
                                                <Grid item xs={12}>
                                                    <FormInput
                                                        field={field}
                                                        value={Filter_itms[field.name] || ''}
                                                        dynamicEnumValue=""
                                                        // errors={errors}
                                                        module={field.module ? field.module : 'Users'}
                                                        onChange={(val) => onChange(val, field)}
                                                        small={true}

                                                    />

                                                </Grid>
                                            </Grid>
                                        </Grid></>
                                )}


                                {parameters.length ?

                                    <Grid item xs={12} >
                                        <AORConditions
                                            type="Dashlet"
                                            data={parameters}
                                            module={module}
                                            handleSubmit={handleSubmitReportFilter}
                                            setFilterAorConditions={setFilterAorConditions}
                                        /> </Grid> : null}

                                {/*parameters.map((field, fieldNum) =>
                                        field.ModuleFieldType ?
                                              
                                      
                                      <>
                                                < Grid item xs={12} sm={6} key={fieldNum} >
                                                    <Grid
                                                        container
                                                        className={classes.fieldSpacing}
                                                        direction="row"
                                                        justify="space-between"
                                                        alignItems="stretch"
                                                    >
                                                        <Grid item xs={12}>
                                                            <FormInput
                                                                field={field.ModuleFieldType}
                                                                // value={''}
                                                                dynamicEnumValue=""
                                                                // errors={errors}
                                                                module={field.module_display ? field.module_display : 'Users'}
                                                                onChange={(val) => onChange(val, field.ModuleFieldType)}
                                                                small={true}

                                                            />

                                                        </Grid>
                                                    </Grid>
                                                </Grid></> 
                                            : null
            )} */}
                            </Grid>
                        </Grid>

                    </>
                </Scrollbars>
            </DialogContent>
        
</>}
<DialogActions>
                {configureDashletLoading ? <Button variant="contained" size="small" color="primary" >
                    Saving  <CircularProgress size={14} style={{ marginLeft: 10, color: "White" }} />
                </Button> :
                    <Button size="small" className={classes.btn} variant="contained" onClick={handleConfigure} color="primary">
                        Save
                </Button>}
                {/* {searchFields ? <Button onClick={handleClear} color="primary">
                            Clear
                </Button> : null} */}
                <Button size="small" className={classes.btn} variant="contained" onClick={handleClose} color="primary">Close</Button>
            </DialogActions>
        </>
    );
}